<div style="padding: 24px;">
    <h5 mat-dialog-title class="text-center">Póliza N° {{data.policyNumber}}</h5>
    <div mat-dialog-content>
      <div class="row mt-2">
        <div class="col-md-12">
          <p><strong>Fecha de creación: </strong>{{data.createdAt | date: 'MMMM d, y'}}</p>
          <p><strong>Sucursal: </strong>{{data.branch}}</p>
          <p><strong>Fecha de inicio: </strong>{{data.dateStart | date: 'MMMM d, y'}}</p>
          <p><strong>Fecha de terminación: </strong>{{data.dateEnd | date: 'MMMM d, y'}}</p>
        </div>
        <div class="col-md-6">
          <h5 class="text-center">Aseguradora</h5>
          <p><strong>Fecha de creación: </strong>{{data.insuranceCompanyEntity?.createdAt | date: 'MMMM d, y'}}</p>
          <p><strong>Nombre: </strong>{{data.insuranceCompanyEntity?.name}}</p>
          <p><strong>Correo electrónico: </strong>{{data.insuranceCompanyEntity?.email}}</p>
          <p><strong>Teléfono: </strong>{{data.insuranceCompanyEntity?.phone | phone}}</p>
          <p><strong>Nit: </strong>{{data.insuranceCompanyEntity?.nit}}</p>
        </div>
        <div class="col-md-6">
          <h5 class="text-center">Broker</h5>
          <p><strong>Fecha de creación: </strong>{{data.brokerEntity?.createdAt | date: 'MMMM d, y'}}</p>
          <p><strong>Nombre: </strong>{{data.brokerEntity?.name}}</p>
          <p><strong>Correo electrónico: </strong>{{data.brokerEntity?.email}}</p>
          <p><strong>Teléfono: </strong>{{data.brokerEntity?.phone | phone}}</p>
          <p><strong>Nit: </strong>{{data.brokerEntity?.nit}}</p>
        </div>
        <div class="col-md-12">
          <h5 class="text-center">Rangos y tasas</h5>
          <div class="mb-2 row" *ngFor="let range of ranges">
            <div class="col-md-6">
              <p class="text-center"><strong>Rango</strong></p>
              <p><strong>Descripción: </strong>{{formatType(range.ranges?.description)}}</p>
              <p *ngIf="isHigthRisk(range.ranges?.description)"><strong>Valor máximo: </strong>{{formatCurrency(range.ranges?.maxAmount)}}</p>
              <p *ngIf="isHigthRisk(range.ranges?.description)"><strong>Moneda: </strong>{{range.ranges?.paramCurrencyEntity?.divisa}}</p>
            </div>
            <div class="col-md-6">
              <p class="text-center"><strong>Tasa</strong></p>
              <p><strong>Tasa: </strong>{{range.rates?.rate}}%</p>
              <p><strong>Prima mínima: </strong>{{formatCurrency(range.rates?.minAmount)}}</p>
              <p><strong>Moneda: </strong>{{range.rates?.paramCurrencyEntity?.divisa}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div mat-dialog-actions>
      <button mat-button (click)="onNoClick(false)">Cerrar</button>
    </div>
  </div>
